import { render, staticRenderFns } from "./DoanhThuBosch.vue?vue&type=template&id=73ac1774&"
import script from "./DoanhThuBosch.vue?vue&type=script&lang=js&"
export * from "./DoanhThuBosch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports